import { api, handleError } from "./baseApi";

export async function getAllSettlements(filters = {}) {
  try {
    const { data } = await api.get("/settlements", {
      params: filters,
    });
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function addSettlements(payload) {
  try {
    const { data } = await api.post("/settlements", payload);
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function updateSettlements(payload, settlementID) {
  try {
    const { data } = await api.put(`/settlements/${settlementID}`, payload);
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function deleteSettlements(settlementID) {
  try {
    const { data } = await api.delete(`/settlements/${settlementID}`);
    return data;
  } catch (error) {
    return handleError(error);
  }
}
